import React from 'react';
import { useNavigate, useParams } from 'react-router';
import type { CandidateEngagement } from '@axiom/validation';
import {
  Accordions,
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  Badge,
  Brief,
  CondensedHeader,
  Gutter,
  Layout,
  SmallHeader,
  TilesItem,
} from '@axiom/ui';

import { EngagementBadges } from '../EngagementBadges/EngagementBadges';
import { EngagementsUtil } from '../../utils/engagements-util';

export type EngagementsAccordionProps = {
  countBadge?: number;
  name: string;
  title: string;
  onTileClick?: () => void;
  engagements: CandidateEngagement[];
};

export const EngagementsAccordion = ({
  countBadge,
  name,
  onTileClick,
  title,
  engagements,
}: EngagementsAccordionProps) => {
  const navigate = useNavigate();
  const { opportunityId } = useParams();
  return (
    <Accordions name={name}>
      <AccordionsItem expanded>
        <AccordionsItemHeader>
          <Layout position="middle space-between">
            <SmallHeader name="TITLE">{title}</SmallHeader>
            {(countBadge ?? 0) > 0 && (
              <Gutter horizontal="8px">
                <Badge
                  background="gray"
                  name="ENGAGEMENTS_ACCORDION_COUNT_BADGE"
                >
                  {countBadge}
                </Badge>
              </Gutter>
            )}
          </Layout>
        </AccordionsItemHeader>
        <AccordionsItemSection>
          <Gutter top="24px">
            <Brief briefMaxChildren={3} pattern="secondary" hideMask>
              {engagements.map((e, i) => {
                const bottomGutter =
                  engagements.length <= 3 && i === engagements.length - 1
                    ? '0px'
                    : '16px';
                return (
                  <Gutter
                    bottom={bottomGutter}
                    key={e.id}
                    name="ENGAGEMENTS_ACCORDION_ITEM"
                  >
                    <TilesItem
                      name={`ENGAGEMENTS_ACCORDION_ITEM_TILE_${e.opportunity.id}`}
                      onClick={() => {
                        onTileClick?.();
                        void navigate(`./${e.opportunity.id}`);
                      }}
                      selected={e.opportunity.id === opportunityId}
                    >
                      {EngagementsUtil.getBadgeConfig({ engagement: e })
                        .length > 0 ? (
                        <Gutter bottom="4px">
                          <EngagementBadges
                            engagement={e}
                            name="ENGAGEMENT_BADGES"
                          />
                        </Gutter>
                      ) : null}

                      <CondensedHeader name="JOB_NAME">
                        {e.opportunity.jobName}
                      </CondensedHeader>
                    </TilesItem>
                  </Gutter>
                );
              })}
            </Brief>
          </Gutter>
        </AccordionsItemSection>
      </AccordionsItem>
    </Accordions>
  );
};
